import React from 'react';
import {Tbody} from '@tempo/core';
import type {ManagerArtist} from '@deezer/next/features/ClaimAccess/types';
import ArtistTableRow from './ArtistTableRow';
import Row from '@components/Table/rows/Row';
import Td from '@components/Table/core/Td';

type ArtistTableBodyProps = {
	data: ManagerArtist[];
	onArtistEdit: (artist: ManagerArtist) => void;
	onArtistRemove: (artist: ManagerArtist) => void;
};

const ArtistTableBody = ({
	data,
	onArtistEdit,
	onArtistRemove,
}: ArtistTableBodyProps) => {
	if (data.length === 0) {
		return (
			<Tbody>
				<Row index={0}>
					<Td height="20px" />
				</Row>
			</Tbody>
		);
	}

	return (
		<Tbody>
			{data.map((artist, rowIndex) => (
				<ArtistTableRow
					key={rowIndex}
					rowIndex={rowIndex}
					artist={artist}
					onArtistEdit={onArtistEdit}
					onArtistRemove={onArtistRemove}
				/>
			))}
		</Tbody>
	);
};

export default ArtistTableBody;
